/**
 * Updates the announcement bar free-shipping threshold for the active market currency.
 * Converts from the shop's EUR base threshold using Shopify Markets rates,
 * rounded up to the next multiple of 10 in the presentment currency.
 */
(function () {
  const AMOUNT_PLACEHOLDER = '@@AMOUNT@@';

  const ZERO_DECIMAL_CURRENCIES = new Set([
    'BIF', 'CLP', 'DJF', 'GNF', 'ISK', 'JPY', 'KMF', 'KRW', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF',
  ]);

  /**
   * @param {string} currency
   * @returns {number}
   */
  function getCurrencyPrecision(currency) {
    return ZERO_DECIMAL_CURRENCIES.has(String(currency).toUpperCase()) ? 0 : 2;
  }

  /**
   * @param {number} minorUnits
   * @param {string} format
   * @param {string} currency
   * @returns {string}
   */
  function formatMoney(minorUnits, format, currency) {
    const precision = getCurrencyPrecision(currency);
    const divisor = Math.pow(10, precision);
    const major = minorUnits / divisor;

    let thousandsSeparator = ',';
    let decimalSeparator = '.';
    let displayPrecision = precision;

    const normalizedFormat = String(format || '{{amount}}');

    if (normalizedFormat.includes('amount_no_decimals')) {
      displayPrecision = 0;
    } else if (normalizedFormat.includes('amount_with_comma_separator')) {
      thousandsSeparator = '.';
      decimalSeparator = ',';
    } else if (normalizedFormat.includes('amount_with_space_separator')) {
      thousandsSeparator = ' ';
      decimalSeparator = ',';
    } else if (normalizedFormat.includes('amount_no_decimals_with_space_separator')) {
      thousandsSeparator = ' ';
      displayPrecision = 0;
    } else if (normalizedFormat.includes('amount_no_decimals_with_comma_separator')) {
      thousandsSeparator = '.';
      displayPrecision = 0;
    }

    const fixed = major.toFixed(displayPrecision);
    const parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    const amount = parts.join(decimalSeparator);

    return normalizedFormat.replace(/{{\s*(\w+)\s*}}/g, (_, token) => {
      if (token === 'currency') return currency;
      if (token.startsWith('amount')) return amount;
      return '';
    });
  }

  /**
   * @param {HTMLElement} element
   */
  function updateFreeShippingAnnouncement(element) {
    const template = element.dataset.messageTemplate;
    if (!template) return;

    const thresholdEur = Number(element.dataset.thresholdEur || 60);
    const moneyFormat = element.dataset.moneyFormat || '{{amount}}';
    const locale = element.dataset.locale || document.documentElement.lang || 'en';
    const shopCurrency = element.dataset.shopCurrency || 'EUR';
    const activeCurrency = window.Shopify?.currency?.active || shopCurrency;
    const rate = Number(window.Shopify?.currency?.rate || 1);

    const convertedMajor = thresholdEur * rate;
    const roundedMajor = Math.ceil(convertedMajor / 10) * 10;

    let formattedAmount;
    try {
      formattedAmount = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: activeCurrency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(roundedMajor);
    } catch (_error) {
      const minorUnits = Math.round(roundedMajor * Math.pow(10, getCurrencyPrecision(activeCurrency)));
      formattedAmount = formatMoney(minorUnits, moneyFormat, activeCurrency);
    }

    element.textContent = template.replace(AMOUNT_PLACEHOLDER, formattedAmount);
    element.hidden = false;
  }

  function init() {
    document.querySelectorAll('[data-free-shipping-announcement]').forEach(updateFreeShippingAnnouncement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
